import * as React from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import {
    CaptionText3,
    FlexColumn,
    H3,
    SectionBody,
    SectionHeader,
} from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { RefinementFilterConfig } from '@portal/common/types';

import DataCollectionSelector from '../../components/DataExplorer/DataCollectionSelector';
import LimitWarnings from '../../components/LimitWarnings';
import _ from '../../locale';
import { getDataToolConfig, getSelectedDataType } from '../../store/data-explorer/selectors';
import ComorbidityConditionSelector from './ComorbidityConditionSelector';
import ComorbidityFiltersControls from './ComorbidityFiltersControls';
import { getComorbidityTabKeyByDataType } from './comorbidity-type-group';

const StyledSectionBody = styled(SectionBody)(({ theme }) => ({
    marginTop: 0,
}));

type Props = {
    refinementFiltersConfig?: RefinementFilterConfig;
    areChartsVisible: boolean;
    toggleChartsVisibility: () => void;
};

const ComorbiditySelectDataSection: FC<Props> = ({
    refinementFiltersConfig,
    toggleChartsVisibility,
    areChartsVisible,
}) => {
    const dataToolConfig = useSelector(getDataToolConfig);
    const dataType = useSelector(getSelectedDataType);

    const currentTabKey = getComorbidityTabKeyByDataType(dataType);
    const isDataCollectionSelectorVisible = dataToolConfig?.dataCollectionSelectorVisibility;

    return (
        <StyledSectionBody>
            <SectionHeader>
                <H3>{_(`comorbidity_${currentTabKey}_tab_select_data`)}</H3>
            </SectionHeader>
            <FlexColumn itemsSpacing={30} grow={1}>
                <CaptionText3>{_(`comorbidity_${currentTabKey}_tab_tooltip`)}</CaptionText3>
                {isDataCollectionSelectorVisible && <DataCollectionSelector />}
                <ComorbidityConditionSelector />
                <ComorbidityFiltersControls
                    refinementFiltersConfig={refinementFiltersConfig}
                    {...{ toggleChartsVisibility, areChartsVisible }}
                />
            </FlexColumn>
            <LimitWarnings />
        </StyledSectionBody>
    );
};

export default ComorbiditySelectDataSection;
